<template>
  <div
    class="d-flex auth-form-body"
    :style="minHeight ? `min-height:${minHeight}px` : ''"
  >
    <div class="w-50 d-flex align-items-center shadow-lg position-relative">
      <div class="px-5" ref="companyProfile">
        <AuthCompanyProfile />
      </div>
    </div>
    <div class="w-50 d-flex align-items-center auth-suggestion">
      <div class="w-50 mx-auto" ref="authForm">
        <form @submit.prevent="handleSubmit" novalidate>
          <h3 class="mb-4 text-center">პაროლის აღდგენა</h3>
          <div class="mb-3">
            <label class="form-label">ელ. ფოსტა</label>
            <input
              type="email"
              class="form-control"
              :class="{ 'is-invalid': emailError }"
              v-model="email"
              :disabled="serverSuccess"
              @focus="emailError = false"
            />
            <div v-if="emailError" class="invalid-feedback">
              {{ emailErrorMessage }}
            </div>
          </div>
          <div
            v-if="serverError"
            class="alert alert-danger mb-3 text-center"
            role="alert"
          >
            {{ serverErrorMessage }}
          </div>
          <div
            v-if="serverSuccess"
            class="alert alert-success mb-3 text-center"
            role="alert"
          >
            {{ serverSuccessMessage }}
          </div>
          <div v-if="spinner" class="spinner mb-3">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-primary rounded-pill px-4 font-caps"
              :disabled="serverSuccess"
            >
              აღდგენა
            </button>
            ან
            <router-link :to="{ name: 'signin' }" class="text-decoration-none"
              >შესვლა</router-link
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import axios from "@/http";
import AuthCompanyProfile from "@/components/AuthCompanyProfile.vue";
import useAuthMinHeight from "@/composables/useAuthMinHeight";

export default {
  components: { AuthCompanyProfile },
  setup() {
    const email = ref("");

    const spinner = ref(false);

    const emailError = ref(false);
    const emailErrorMessage = ref("");

    const serverError = ref(false);
    const serverErrorMessage = ref("");
    const serverSuccess = ref(false);
    const serverSuccessMessage = ref("");

    const { minHeight, companyProfile, authForm } = useAuthMinHeight();

    const handleSubmit = async () => {
      if (email.value.length === 0) {
        emailError.value = true;
        emailErrorMessage.value = "ელ. ფოსტის ველი ცარიელია";
      } else if (!/\S+@\S+\.\S+/.test(email.value)) {
        emailError.value = true;
        emailErrorMessage.value = "ელ. ფოსტის მისამართი არასწორია";
      }

      if (!emailError.value) {
        serverError.value = false;
        spinner.value = true;

        const res = await axios.post("/forgetPassword", {
          email: email.value,
        });

        spinner.value = false;

        if (res.data.success) {
          serverSuccess.value = true;
          serverSuccessMessage.value = res.data.message;
        } else {
          serverError.value = true;
          serverErrorMessage.value = res.data.message;
        }
      } else {
        serverSuccess.value = false;
      }
    };

    return {
      email,
      emailError,
      emailErrorMessage,
      serverSuccess,
      serverSuccessMessage,
      serverError,
      serverErrorMessage,
      handleSubmit,
      spinner,
      companyProfile,
      authForm,
      minHeight,
    };
  },
};
</script>

<style>
</style>